export class AvorionGalaxyUI {
  public galaxyListElement: JQuery = $('[data-name="galaxy"]');
  public galaxyNameElement: JQuery = $('[data-name="galaxy-name"]');
  public galaxyNameWrapperElement: JQuery = $('[data-name="galaxy-name-wrapper"]');

  public onGalaxyChange(callback: (value: string) => void) {
    this.galaxyListElement.on('change', (event) => {
      callback(this.galaxyListElement.val() as string);
    });
  }

  private getGalaxyFieldElement(name: string): JQuery {
    return $('[data-name="' + name + '"]');
  }

  public getGalaxyFieldValue(name: string): string {
    const el = this.getGalaxyFieldElement(name);

    // Special handling for fancy checkboxes
    if (el.hasClass('fancy-checkbox')) {
      if (window.findCheckboxByBaseAttribute('data-name', name).ui.active) {
        return el.attr('data-true');
      } else {
        return el.attr('data-false');
      }
    }

    return el.val().toString();
  }

  public setGalaxyFieldValue(name: string, value: string) {
    const el = this.getGalaxyFieldElement(name);

    // Special handling for fancy checkboxes
    if (el.hasClass('fancy-checkbox')) {

      if (value === el.attr('data-true')) {
        window.findCheckboxByBaseAttribute('data-name', name).ui.setActive();
      } else {
        window.findCheckboxByBaseAttribute('data-name', name).ui.setInactive();
      }
    }

    el.val(value);
  }
}
